import { render, staticRenderFns } from "./PaymentMethodItemIcon.vue?vue&type=template&id=624c5031&scoped=true&"
import script from "./PaymentMethodItemIcon.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodItemIcon.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentMethodItemIcon.vue?vue&type=style&index=0&id=624c5031&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624c5031",
  null
  
)

export default component.exports